import { Component } from '@angular/core';

@Component({
  selector: 'my-bill-deferral-rules-list',
  templateUrl: './deferral-rules-list.component.html',
  standalone: false,
})
export class DeferralRulesListComponent {}
